import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getDict as _getDict } from '@/utils/dictionary';
import { formatTimeToStr, timeStamp } from '@/utils/date';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
export default {
  data: function data() {
    return {
      page: 1,
      total: 10,
      pageSize: 10,
      tableData: [],
      searchInfo: {},
      objData: {}
    };
  },
  methods: {
    exportExcel: function exportExcel(name, id, ab, flag) {
      // let wb = XLSX.utils.table_to_book(document.querySelector(id));
      // /* get binary string as output */
      // let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      // try {
      //   FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), name);
      // } catch (e)
      // {
      //   if (typeof console !== 'undefined')
      //     console.log(e, wbout)
      // }
      // return wbout
      var fix;
      // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
      if (flag != undefined) {
        var dom = document.getElementsByClassName('el-dialog')[flag];
        fix = dom.querySelector('.el-table__fixed');
      } else fix = document.querySelector('.el-table__fixed');
      if (!ab) {
        var xlsxParam = {
          raw: true
        };
      } // 转换成excel时，使用原始的格式
      var wb;
      if (fix) {
        wb = XLSX.utils.table_to_book(document.querySelector(id).removeChild(fix), xlsxParam);
        document.querySelector(id).appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector(id), xlsxParam);
      }
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      try {
        FileSaver.saveAs(new Blob([wbout], {
          type: 'application/octet-stream;charset=utf-8'
        }), name);
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout);
      }
      return wbout;
    },
    filterDict: function filterDict(value, type) {
      var rowLabel = this[type + 'Options'] && this[type + 'Options'].filter(function (item) {
        return item.value === value;
      });
      return rowLabel && rowLabel[0] && rowLabel[0].label;
    },
    getDict: function getDict(type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dicts;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return _getDict(type);
            case 1:
              dicts = _context.sent;
              _this[type + 'Options'] = dicts;
              return _context.abrupt("return", dicts);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.pageSize = val;
              _context2.next = 1;
              return _this2.getTableData();
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.page = val;
              _context3.next = 1;
              return _this3.getTableData();
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
        _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var page, pageSize, table;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this4.page;
              pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this4.pageSize;
              _context4.next = 1;
              return _this4.listApi(_objectSpread({
                page: page,
                pageSize: pageSize
              }, _this4.searchInfo));
            case 1:
              table = _context4.sent;
              if (table.code === 0) {
                _this4.objData = table.data;
                _this4.tableData = table.data.list;
                if (table.data.total) {
                  _this4.total = table.data.total;
                  _this4.page = table.data.page;
                  _this4.pageSize = table.data.pageSize;
                } else {
                  _this4.total = 999999;
                }
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.page = 1;
              _context5.next = 1;
              return _this5.getTableData();
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    searchOption: function searchOption(obj, value, msg) {
      for (var i in obj) {
        if (obj[i] === value) {
          if (isNaN(parseInt(i))) {
            console.log(i);
            return i;
          }
          return parseInt(i);
        }
      }
      if (msg == -2) {
        return -2;
      }
      return -1;
    },
    formatTimeOne: function formatTimeOne(time, status) {
      if (status === 'start') {
        if (time === null) {
          this.searchInfo.StartTime = -1;
          return;
        } else {
          this.searchInfo.StartTime = timeStamp(time);
          return;
        }
      } else if (status === 'end') {
        if (time === null) {
          this.searchInfo.EndTime = -1;
          return;
        } else {
          this.searchInfo.EndTime = timeStamp(time);
          return;
        }
      }
    },
    formatTimeTow: function formatTimeTow(time, status) {
      if (status === 'start') {
        if (time === null) {
          this.searchInfo.StartTime = null;
          return;
        } else {
          this.searchInfo.StartTime = formatTimeToStr(time, 'yyyy-MM-dd');
          return;
        }
      } else if (status === 'end') {
        if (time === null) {
          this.searchInfo.EndTime = null;
          return;
        } else {
          this.searchInfo.EndTime = formatTimeToStr(time, 'yyyy-MM-dd');
          return;
        }
      }
    },
    trimFormat: function trimFormat(str) {
      return str.replace(/(^\s*)|(\s*$)/g, '');
    }
  }
};